



































import CardSuratJawabanRujukan from "@/components/pemeriksaan/konsulRujukan/CardSuratJawabanRujukan.vue";
import CardSuratKonsul from "@/components/pemeriksaan/konsulRujukan/CardSuratKonsul.vue";
import CardSuratRujukanIgd from "@/pages/PemeriksaanIgdPage/CardSuratRujukanIgd.vue";
import { storeRujukan } from "@/store/modules/rujukan";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    CardSuratKonsul,
    CardSuratRujukanIgd,
    CardSuratJawabanRujukan
  },
  beforeRouteLeave(to, from, next) {
    // reset props showingModal biar ketika berkunjung kembali ke page ini dg param yg sama ttp nriger watch
    this.showingModal = null;
    next();
  }
})
export default class KonsulRujukanTabView extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  @Prop() readonly showingModal?: string;

  tabKonsul = "konsul-keluar";
  subTab = "sub-konsul";
  tab = "tab-soap";
  modalRujukan = false;

  mounted() {
    this.showModal(this.showingModal);
  }

  showTab(item) {
    this.tab = item;
  }

  showModal(modal) {
    if (modal) {
      if (modal === "rujukan") {
        console.log("showing modal rujukan");
        this.$nextTick(() => {
          // this.modalRujukan = true;
          storeRujukan.openInput();
        });
      }
    }
  }

  @Watch("showingModal")
  changeShowingModal(val) {
    this.showModal(val);
  }
}
